import axios from 'axios'
const url = 'https://www.lefisc.com.br/api/beneficioEmergencial/calcular/'
const chave = '68ac125af89bd60913c06bc30a565341' 
export default {
    getTextoNotaSuspensaoContrato(){
        return axios
        .get(`${url}/textoNotaSuspensaoContrato/${chave}`)
        .then(res=> res.data)
        .catch(err=> console.log(err))
    },
    getTextoNotaReducaoTrabalho(){
        return axios
        .get(`${url}/textoNotaReducaoTrabalho/${chave}`)
        .then(res=> res.data)
        .catch(err=> console.log(err))
    },
    getTextoExplicativaMP(){
        return axios
        .get(`${url}/textoExplicativaMP/${chave}`)
        .then(res=> res.data)
        .catch(err=> console.log(err))
    },
    getTextoInicial(){//ja foi - pagina inicial superior
        return axios
            .get(`${url}/textoInicial/${chave}`)
            .then(res=> res.data)
            .catch(err=> console.log(err))
    },
    getTextoInferior(){
        return axios
        .get(`${url}/textoInferior/${chave}`)
        .then(res=> res.data)
        .catch(err=> console.log(err))
    },
    getTextoSuperiro(){
        return axios
        .get(`${url}/textoSuperior/${chave}`)
        .then(res=> res.data)
        .catch(err=> console.log(err))
    },
    getTextoReducaoSuspensao(){//ja foi - pagina SuspensaoGeral 
        return axios
        .get(`${url}/textoReducaoSuspensao/${chave}`)
        .then(res=> res.data)
        .catch(err=> console.log(err))
    },
    getTextoReducaoJornada(){//ja foi - pagina Redução Geral
        return axios
        .get(`${url}/textoReducaoJornada/${chave}`)
        .then(res=> res.data)
        .catch(err=> console.log(err))
    },
    getSuspensao(salarioAtual, uSalario, pSalario, aSalario, faturamentoSuperior, domestico) {
        return axios
            .post(`${url}suspensao/${chave}`, {             
                    "salarioAtual": salarioAtual,
                    "uSalario": uSalario, 
                    "pSalario": pSalario, 
                    "aSalario": aSalario,
                    "faturamentoSuperior": faturamentoSuperior,
                    "domestico": domestico            
            })
            .then(res => res.data)
            .catch(err => console.log(err));
    },
    getReducao(salarioAtual, uSalario, pSalario, aSalario, percentual, domestico) {
        return axios
            .post(`${url}reducao/${chave}`, {             
                "salarioAtual": salarioAtual,
                "uSalario": uSalario,
                "pSalario": pSalario,
                "aSalario": aSalario,
                "percentual": percentual,
                "domestico": domestico,         
            })
            .then(res => res.data)
            .catch(err => console.log(err));
    },
    getReducaoD(salarioAtual, percentual, domestico) {
        return axios
            .post(`${url}reducao/${chave}`, {             
                "salarioAtual": salarioAtual,
                "percentual": percentual,
                "domestico": domestico,         
            })
            .then(res => res.data)
            .catch(err => console.log(err));
    },
    getSuspensaoD(salarioAtual, domestico) {
        return axios
            .post(`${url}suspensao/${chave}`, {             
                "salarioAtual": salarioAtual,
                "domestico": domestico,         
            })
            .then(res => res.data)
            .catch(err => console.log(err));
    },
}


